<template>
  <v-container style="height: 100%">

    <v-card flat>
      <v-card-title class="title subprimary">
        <span>История изменения статусов:</span>
        <v-spacer></v-spacer>

      </v-card-title>
      <v-card-text class="pb-3 pt-1">


        <v-expansion-panel>
          <v-expansion-panel-content
            v-for="item,i in items"
            :key="i"
          >
            <template v-slot:header>
              <div>{{findNameObj('candidateCase',item[0].candidateCase)}}</div>
            </template>
            <v-card>
              <v-card-text>
                <v-card-text v-for="it,j in item">
                  {{findNameObj('status',it.status)}}
                  {{displayDate(it.setDate,true)}}
                </v-card-text>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>

      </v-card-text>
    </v-card>

  </v-container>
</template>


<script>

  import urls from "../../../../../modules/petition/urls"
  import UserDataMixin from '../../../../../mixins/UserDataMixin'
  import {makeGetRequest} from "../../../../../helper";
  import moment from "moment"

  export default {
    name: "ListStatus_history",

    mixins: [UserDataMixin],

    data: function () {
      return {
        URL_LIST: urls.getUrl('admin|case|models|status_history-list', 'list'),
        URL_DELETE: urls.getUrl('admin|case|models|status_history-detail', 'destroy'),

        selectors: {
          candidateCase: [],
          person: [],
          status: [],
        },

        items: [],
        headers: [
          {
            text: 'Дело', sortable: false, align: 'justify-center',
          },
          {
            text: 'Оппонент', sortable: false, align: 'justify-center',
          },
          {
            text: 'Отзыв', sortable: false, align: 'justify-center',
          },
          {
            text: 'Действия',
            align: 'justify-center',
            sortable: false,
          },
        ],

      }
    },

    methods: {
      groupBy(xs, key) {
        return xs.reduce(function (rv, x) {
          (rv[x[key]] = rv[x[key]] || []).push(x);
          return rv;
        }, {});
      },
      displayDate: function (date, minutes = false) {
        let format = 'DD.MM.YYYY'
        if (minutes)
          format += ' HH:mm'
        return moment(date).format(format)
      },
      load: function (app, url, field) {
        if (url === null) {
          app.loadingPage = true;
          return;
        }
        makeGetRequest(url)
          .then(resp => resp.json())
          .then(json => {
            let next_url = null;
            if (json['next'] !== null)
              next_url = url.split('?')[0] + '?' + json['next'].split('?')[1];
            for (let i in json['results']) {
              app.selectors[field].push(Object.assign({}, json['results'][i]));
            }
            app.load(app, next_url, field);
          });
      },
      findNameObj(edit, id) {
        let obj = this.selectors[edit].find(item => item.value === id);
        if (obj !== undefined) {
          return obj.text
        } else {
          return ""
        }
      },
      getItems() {
        let url = urls.getUrl('admin|case|models|status_history-list', 'list');

        let sys = true
        makeGetRequest(url).then(resp => {
          if (!resp.ok) {
            sys = false
          }
          return resp.json()
        }).then(json => {
          let data = this.groupBy(json, 'candidateCase');//группируем по анкетам
          for (let key in data) {
            data[key].sort(function (a, b) {//сортируем по очереди создания внутри анкеты
              return a.id - b.id
            })
          }

          this.items = data;


        })
      },
    },
    created() {
      let url = urls.getUrl('admin|case|selectors|candidate_case', 'get')
      this.load(this, url, 'candidateCase')
      makeGetRequest(process.env.VUE_APP_API_HOST + "council/admin/case/choices/status_choices/").then(resp => {
        if (!resp.ok) {
          sys = false
        }
        return resp.json()
      }).then(json => {
        this.selectors.status = json
      })
      this.getItems();

    },
  }


</script>
<style scoped>

</style>
